import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import clsx from 'clsx';
function _CheckRoundFill(props, ref) {
    const { className, ...rest } = props;
    const classes = clsx('go-icon', className);
    return _jsx("span", { className: classes, ref: ref, ...rest, children: _jsx("svg", { width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24", children: _jsx("path", { fill: "currentColor", fillRule: "evenodd", d: "M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18m4.768-11.36a1 1 0 1 0-1.536-1.28l-3.598 4.317c-.347.416-.542.647-.697.788l-.006.006-.007-.005c-.168-.127-.383-.339-.765-.722l-1.452-1.451a1 1 0 0 0-1.414 1.414l1.451 1.451.041.041c.327.327.64.641.933.862.327.248.756.48 1.305.456.55-.025.956-.296 1.26-.572.27-.247.555-.588.85-.943l.037-.044z", clipRule: "evenodd" }) }) });
}
const CheckRoundFill = forwardRef(_CheckRoundFill);
export { CheckRoundFill };
